<template>
  <div class="card border-0 radius-7 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between"
      >
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Mês de referência
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Data do pagamento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Pagamento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in getInvoiceHistory" :key="key">
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.month }}/{{ item.year }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.status }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                <span v-if="item.date_payment_formatted">{{ item.date_payment_formatted }}</span>
                <span v-else class="text-muted fs-13">Não pago</span>
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                <a
                  v-if="item.payment_url"
                  :href="item.payment_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="payment-history__link"
                  title="Abrir link de pagamento"
                  aria-label="Abrir link de pagamento em uma nova aba"
                >
                  <i class="ph ph-arrow-square-out"></i>
                </a>
                <span v-else class="text-muted fs-13">Indisponível</span>
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                R$ {{ item.value_formatted }}
              </td>
            </tr>
            <tr v-if="!getInvoiceHistory || getInvoiceHistory.length === 0">
              <td colspan="5" class="shadow-none text-center text-muted py-4">
                Nenhum pagamento encontrado.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getInvoiceHistoryPagination.last_page || 1 }} —
          Total de {{ getInvoiceHistoryPagination.total || (getInvoiceHistory ? getInvoiceHistory.length : 0) }} pagamentos
        </div>
        <nav aria-label="Paginação do histórico de pagamentos">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getInvoiceHistoryPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getInvoiceHistoryPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: "PaymentHistory",
  data() {
    return {
      currentPage: 1,
    };
  },
  computed:{
    ...mapGetters([
      'getInvoiceHistory',
      'getInvoiceHistoryPagination'
    ])
  },
  methods: {
    ...mapActions([
      'setInvoiceHistory'
    ]),
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }

      this.currentPage = page;
      await this.setInvoiceHistory(page);
      this.currentPage = this.getInvoiceHistoryPagination.current_page || page;
    },
    goToPage(page) {
      if (page < 1 || (this.getInvoiceHistoryPagination.last_page && page > this.getInvoiceHistoryPagination.last_page)) {
        return;
      }

      this.loadPage(page);
    }
  }
});
</script>

<style scoped>
.payment-history__link {
  align-items: center;
  background-color: rgba(101, 96, 240, 0.1);
  border: 1px solid rgba(101, 96, 240, 0.18);
  border-radius: 6px;
  color: var(--splash-primary-color);
  display: inline-flex;
  height: 34px;
  justify-content: center;
  text-decoration: none;
  transition: var(--transition);
  width: 38px;
}

.payment-history__link:hover {
  background-color: var(--splash-primary-color);
  color: #fff;
}

.payment-history__link i {
  font-size: 18px;
  line-height: 1;
}
</style>
